<template>
  <nav class="navbar">
    <div class="navbar__main">
      <router-link to="/">
        <img src="../assets/logos/Brand.svg" alt="tich" width="160" height="65" />
      </router-link>
      <div class="navbar__main_menu">
        <a class="spacing__mr_6 text__content text__link" @click="scrollTo('features')">
          {{ $t('navbar.features') }}
        </a>
        <a class="spacing__mr_6 text__content text__link" @click="scrollTo('contact')">
          {{ $t('navbar.contact') }}
        </a>
        <button class="button_secondary" @click="$router.push('access')">
          {{ $t('navbar.request_access') }}
        </button>
      </div>
      <img
        src="../assets/hamburguer.svg"
        alt="menu"
        class="navbar__mobile_hamburger"
        @click="shouldShowSidebar = !shouldShowSidebar"
      />
    </div>
    <TheSidebarNav
      v-show="shouldShowSidebar"
      :slide-in-menu="shouldShowSidebar"
      @close="shouldShowSidebar = false"
    />
  </nav>
</template>

<script>
import TheSidebarNav from './TheSidebarNav'
export default {
  name: 'TheNavbar',
  components: {
    TheSidebarNav,
  },
  data() {
    return {
      shouldShowSidebar: false,
    }
  },
  methods: {
    scrollTo(ref) {
      document.querySelector(`#${ref}`).scrollIntoView({
        behavior: 'smooth',
      })
    },
  },
}
</script>

<style lang="scss" scoped>
.navbar {
  background-color: white;
  justify-content: space-between;
  display: flex;
  width: 100%;

  &__main {
    align-items: center;
    display: flex;
    justify-content: space-between;
    width: 100%;

    &_menu {
      align-items: center;
      display: flex;

      & button {
        width: 152px;
      }
    }
  }

  &__mobile_hamburger {
    display: none;
  }
}

@media only screen and (max-width: 768px) {
  .navbar__mobile_hamburger {
    display: block;
  }

  .navbar__main_menu {
    display: none;
  }
}
</style>
